import React from 'react'
import { Heading, Icon, Link } from 'components'

const Column = ({ heading, items, innerColumns, ...props }) => {
  return (
    <div {...props}>
      <Heading className="text-white text-xl">{heading}</Heading>

      <ul
        className={`mt-4 space-y-2 text-gray-300 ${
          innerColumns === 2 ? 'grid grid-cols-2 gap-x-12' : ''
        }`}
      >
        {items.map(({ id, title, slug }) => (
          <li key={id}>
            <Link className="text-gray-300" to={slug}>
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Column
